export const CRITICAL_EVENT_TYPES: readonly string[] = ['Panic'];
